/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_Icon_HeaderInputs */



/**
* | output |
* | --- |
* | "Icon" |
*
* @param {Speakers_Table_Icon_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_icon_header = /** @type {((inputs?: Speakers_Table_Icon_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_Icon_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Icone")
	if (locale === "de") return /** @type {LocalizedString} */ ("Symbol")
	if (locale === "it") return /** @type {LocalizedString} */ ("Icona")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Икона")
	if (locale === "es") return /** @type {LocalizedString} */ ("Icono")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("图标")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アイコン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आइकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ícone")
	return /** @type {LocalizedString} */ ("Icon")
});